import { useState } from 'react';
import {
  Form, Input, Select, FormInstance, Alert,
} from 'antd';
import { useMediaQuery } from 'react-responsive';
import { useCountriesGetAll } from '../../../../../hooks/api/createaccount';

interface StepProps {
  form: FormInstance<any>;
  setCountryId: (id: number) => void;
  countryId?: number;
}

const { Option } = Select;

export default function FirstStep({
  countryId,
  form,
  setCountryId,
}: StepProps) {
  const countriesGetAll = useCountriesGetAll();
  const { data, loading } = countriesGetAll;
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 101 }, (_, i) => currentYear - i);
  const isTablet = useMediaQuery({
    query: '(max-width: 768px)',
  });

  const [underage, setUnderage] = useState(false); // Стейт для ошибки возраста

  const validateAge = (year: number) => {
    const age = currentYear - year;

    if (age < 16) {
      setUnderage(true);
      // message.error('You must be at least 16 years old!');
      form.setFieldsValue({ yearBirth: null });
    } else {
      setUnderage(false);
    }
  };

  return (
    <Form form={form} layout="vertical">
      {underage && (
        <Alert
          message="Sorry, you must be at least 16 years old to continue."
          description="We value your participation, but age restrictions apply.
           Please return when you meet the requirement."
          type="warning"
          showIcon
          style={{ marginBottom: 16, marginTop: 16 }}
        />
      )}

      <div
        style={
          isTablet
            ? { display: 'flex', flexDirection: 'column' }
            : { display: 'flex', gap: '8px' }
        }
      >
        <Form.Item
          name="name"
          label="Please Create a Username *"
          rules={[
            { required: true, message: 'Please enter' },
            { max: 50, message: 'Must be 50 characters or fewer' },
          ]}
          style={isTablet ? {} : { width: '60%' }}
        >
          <Input size="large" placeholder="Type here" />
        </Form.Item>
        <Form.Item
          name="yearBirth"
          label="What year were you born? *"
          rules={[{ required: true, message: 'Please select a year' }]}
          style={isTablet ? {} : { width: '40%' }}
        >
          <Select
            placeholder="Select year"
            style={{ width: '100%' }}
            size="large"
            onChange={validateAge}
          >
            {years.map((year) => (
              <Option key={year} value={year}>
                {year}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </div>
      <div
        style={
          isTablet
            ? { display: 'flex', flexDirection: 'column' }
            : { display: 'flex', gap: '8px' }
        }
      >
        <Form.Item
          name="countryId"
          label="Choose Your Country *"
          rules={[{ required: true, message: 'Please select' }]}
          style={isTablet ? {} : { width: '60%' }}
        >
          <Select
            size="large"
            showSearch
            placeholder={loading ? 'Loading countries...' : 'Select'}
            loading={loading}
            options={data?.data
              ?.slice()
              // eslint-disable-next-line no-nested-ternary
              ?.sort((a, b) => (a.id === 233 ? -1 : (b.id === 233 ? 1 : 0)))
              .map((country) => ({
                value: country.id,
                label: country.name,
              }))}
            onChange={(value) => setCountryId(value)}
            filterOption={(input, option) => option?.label?.toLowerCase().includes(input.toLowerCase())
              ?? false}
          />
        </Form.Item>
        {countryId === 233 ? (
          <Form.Item
            name="zipCode"
            label="Zip Code *"
            rules={[{ required: true, message: 'Please enter' }]}
            style={isTablet ? {} : { width: '40%' }}
          >
            <Input size="large" placeholder="Enter Zip Code" />
          </Form.Item>
        ) : null}
      </div>
    </Form>
  );
}
